export var DEFAULT_HOOKS = ['activate', 'mount', 'update'];